import { Component, Inject, Input, Output } from 'ng-forward'; //from 'ng-metadata/core';

@Component({
	selector: 'ng-forward-hack',
	templateUrl: 'components/primoExplore/ng-forward-hack.html',
})

export class NgForwardHack {
	
	constructor() {
		

	}



}


// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/ngForwardHack.directive.ts